// extracted by mini-css-extract-plugin
export var button = "_hf-0";
export var donut = "_hf-1";
export var donutFill = "_hf-3";
export var donutTrack = "_hf-2";